import { render, staticRenderFns } from "./149.vue?vue&type=template&id=3f884376&scoped=true&"
var script = {}
import style0 from "./149.vue?vue&type=style&index=0&id=3f884376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f884376",
  null
  
)

export default component.exports